<!-- Content to display if no dynamic component. -->
@if (!instance) {
<ng-content />
}

<!-- Container of the dynamic component -->
<ng-container #dynamicComponent />
